// extracted by mini-css-extract-plugin
export default {"uploadDocumentContainer":"style_uploadDocumentContainer__4pqz1","title":"style_title__YAlXb","body":"style_body__0VPNg","uploader":"style_uploader__hHxPv"};